import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { listContentVersions } from "../../../api/content/workflowsApi";
import { useLoad } from "../../../shared/loading/useLoad";
import { parseCollectionVersionRef } from "../../../shared/references/contentReferences";
import { labelOf, useVersionLabels } from "./useVersionLabels";
import { modelVersionName } from "./versionChoiceText";

/** F77: one name for an exact model version, including pins outside the newest page. */
export function useContentVersionName(projectId: string | null, requested: string | null) {
  const { t, i18n } = useTranslation();
  const requestedCommit = parseCollectionVersionRef(requested ?? "")?.commit ?? requested;
  const load = useCallback((signal: AbortSignal) => projectId === null || requestedCommit === null ? Promise.resolve([]) : listContentVersions(projectId, signal, requestedCommit), [projectId, requestedCommit]);
  const { state } = useLoad(load);
  // Release requests carry a bare commit; the listing owns its exact collection reference.
  const version = state.status === "loaded" ? state.value.find((entry) => entry.reference === requested || entry.commit === requested) : undefined;
  const reference = version?.reference ?? (parseCollectionVersionRef(requested ?? "") === null ? null : requested);
  const labels = useVersionLabels(projectId ?? "", { itemVersions: [], collectionVersions: reference === null ? [] : [reference] });
  const label = labelOf(labels, reference);
  const name = version === undefined ? label?.version ?? t("versions.unlabelled") : modelVersionName(label, version, i18n.resolvedLanguage);
  return { name, reference };
}
